import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import aboutData from "../json/about.json"; // Importing about.json
import CounselingFormModal from "../components/CounselingFormModal";

export const About = () => {
  const [aboutContent, setAboutContent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    document.title = aboutData.title;
    AOS.init({ duration: 800, once: false });
    setAboutContent(aboutData);
  }, []);

  if (!aboutContent) return null; // Prevent rendering before data is loaded

  return (
    <>
      {/* About Content Section */}
      <section className="aboutPage-content">
        <div className="container">
          <div className="about-image mb-5">
            <img src={aboutContent.aboutSection.image} alt="About" />
          </div>
          <div className="numbers text-center mb-5 container">
            <div className="row justify-content-center">
              {aboutContent.aboutSection.stats.map((stat, index) => (
                <div
                  className="col-12 col-sm-6 col-md-4 d-flex justify-content-center mb-4"
                  key={index}
                >
                  <div className="number-box text-center p-3">
                    <p className="digit">{stat.digit}</p>
                    <span>{stat.label}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="body-text pt-5">
            <div className="row">
              <div className="col-lg-6">
                <div className="body-heading">
                  <h2>{aboutContent.aboutSection.title}</h2>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="body-text">
                  {aboutContent.aboutSection.paragraphs.map((para, index) => (
                    <p key={index}>{para}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Free Counseling Section */}
      <section className="book-free-counseling">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="bfc-top d-flex justify-content-center">
                <div className="image-container">
                  <div className="logo-cont">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div className="image">
                    <img
                      src={aboutContent.counselingSection.image}
                      alt="Counseling"
                    />
                  </div>
                </div>
              </div>
              <div className="bfc-heading mt-4 text-center">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: aboutContent.counselingSection.heading,
                  }}
                ></h2>
              </div>
              <div className="bfc-supporting-text mt-3 text-center">
                <p>{aboutContent.counselingSection.text}</p>
              </div>
              <div className="bfc-buttons text-center mt-5">
                <button
                  type="button"
                  className="btn btn-primary bfc-btn"
                  onClick={() => setShowModal(true)}
                >
                  {aboutContent.counselingSection.button}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CounselingFormModal
        open={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};
